import { createSlice } from "@reduxjs/toolkit";
import { pending_programmes } from "../../../types/core_ibass";

export const accreditedProgrammes = createSlice({
  name: "accredited_programmes",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: pending_programmes;
      }[],
      data: [] as pending_programmes,
    },
  },
  reducers: {
    update_accredited_programmes: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_accredited_programme: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    addToPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_accredited_programme: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_accredited_programme: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_accredited_programmes: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_accredited_programmes,
  add_accredited_programme,
  addToPaginationHistory,
  remove_accredited_programme,
  replace_accredited_programme,
  clear_accredited_programmes,
} = accreditedProgrammes.actions;

export default accreditedProgrammes.reducer;
